/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeProject_ProjectJobs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Project Job Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, June 27, 2019 - 12:00:28 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      06/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const PROJECTJOB_LIST_CONTAINER_LOADED = 'PROJECTJOB_LIST_CONTAINER_LOADED';
export const PROJECTJOB_LIST_CONTAINER_UNLOADED = 'PROJECTJOB_LIST_CONTAINER_UNLOADED';
export const PROJECTJOB_LIST_TABLE_LOADED = 'PROJECTJOB_LIST_TABLE_LOADED';
export const PROJECTJOB_LIST_TABLE_UNLOADED = 'PROJECTJOB_LIST_TABLE_UNLOADED';
export const PROJECTJOB_LIST_LOADED = 'PROJECTJOB_LIST_LOADED';

export const PROJECTJOB_LIST_CHANGE_GROUP = 'PROJECTJOB_LIST_CHANGE_GROUP';
export const PROJECTJOB_SELECT_ROW = 'PROJECTJOB_SELECT_ROW';

export const PROJECTJOB_SET_GROUP_SELECT = 'PROJECTJOB_SET_GROUP_SELECT';
export const PROJECTJOB_SET_FILTER = 'PROJECTJOB_SET_FILTER';
export const PROJECTJOB_LIST_COMPLETE = 'PROJECTJOB_LIST_COMPLETE';

export const PROJECTJOB_LIST_STATUS = 55;
export const PROJECTJOB_LIST_JOBTYPE = 52;
export const PROJECTJOB_LIST_PRIORITY = 53;
export const PROJECTJOB_LIST_SEVERITY = 54;

export const PROJECTJOB_UPDATE_VALUE = 'PROJECTJOB_UPDATE_VALUE';

export const PROJECTJOB_ADD = 'PROJECTJOB_ADD';
export const PROJECTJOB_EDIT = 'PROJECTJOB_EDIT';
export const PROJECTJOB_DELETE = 'PROJECTJOB_DELETE';
export const PROJECTJOB_OPEN_WARNING = 'PROJECTJOB_OPEN_WARNING';
export const PROJECTJOB_CLOSE_WARNING = 'PROJECTJOB_CLOSE_WARNING';
export const PROJECTJOB_DELETE_DISABLE = 'PROJECTJOB_DELETE_DISABLE';
export const PROJECTJOB_VIEW_CHILD_ITEMS = 'PROJECTJOB_VIEW_CHILD_ITEMS';

export const PROJECTJOB_OPEN_EDITHISTORY = 'PROJECTJOB_OPEN_EDITHISTORY';
export const PROJECTJOB_CLOSE_EDITHISTORY = 'PROJECTJOB_CLOSE_EDITHISTORY';

export const PROJECTJOB_EDIT_CONTAINER_LOADED = 'PROJECTJOB_EDIT_CONTAINER_LOADED';
export const PROJECTJOB_EDIT_CONTAINER_UNLOADED = 'PROJECTJOB_EDIT_CONTAINER_UNLOADED';
export const PROJECTJOB_EDIT_FORM_LOADED = 'PROJECTJOB_EDIT_FORM_LOADED';
export const PROJECTJOB_EDIT_FORM_UNLOADED = 'PROJECTJOB_EDIT_FORM_UNLOADED';
export const PROJECTJOBHISTORY_SELECT_ROW = 'PROJECTJOBHISTORY_SELECT_ROW';

export const PROJECTJOB_EDIT_DATA_LOAD = 'PROJECTJOB_EDIT_DATA_LOAD';

export const PROJECTJOB_EDIT_CONTAINER_SUBMIT = 'PROJECTJOB_EDIT_CONTAINER_SUBMIT';
export const PROJECTJOB_EDIT_CONTAINER_CANCEL = 'PROJECTJOB_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeProject_ProjectJobs.js